import React from 'react'
import Link from '@/components/Link'

import { Sizes } from '@/ui/Img/image'
import { ProfileImageLink } from './ProfileImageLink'
import { ProfileImage } from './ProfileImage'
import {
  isGroupWithStats,
  BasicGroup,
  BasicGroupWithStats,
} from '@/types/groups'

export type Props = {
  group: BasicGroup | BasicGroupWithStats
  className?: string
  size?: Sizes
  stats?: boolean
  onClick?: (group: BasicGroup | BasicGroupWithStats) => void
}

export const ProfileBasic = ({
  group,
  className,
  size = 'profile-small',
  stats = true,
  onClick,
}: Props): React.ReactElement => {
  const containerClasses = `${className} fs-unmask profile-basic media media--${size.replace(
    'profile-',
    ''
  )}`
  if (!group) return null

  return (
    <div
      className={containerClasses}
      onClick={
        onClick
          ? e => {
              onClick(group)
            }
          : undefined
      }
    >
      <span className="media__img profile-basic__img">
        {onClick ? (
          <ProfileImage group={group} size={size || 'profile-large'} />
        ) : (
          <ProfileImageLink group={group} size={size || 'profile-large'} />
        )}
      </span>

      <div className="media__body">
        <Link
          href={group.url}
          className="profile-basic__name media__title"
          target={onClick ? '_blank' : undefined}
        >
          <span className="profile-basic__name-text">{group.title}</span>
        </Link>

        {stats && isGroupWithStats(group) ? (
          <div className="profile-basic__info">
            <div className="profile-basic__stats">
              {[group.member_count_label, group.cases_count_label]
                .filter(x => !!x)
                .join(' | ')}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default ProfileBasic
